<script setup>

import {ref} from "vue";
import {useRouter} from "vue-router";

const Keywords = ref()
const current = ref(1)

const router = useRouter()


function getSearch() {
  const search = Keywords.value.trim()
  router.push({
    query: {project_title: search}
  })
}


</script>

<template>
  <div class="em-quearys-inner">
    <div class="em-quearys-form">
      <form class="top-form-control" action="/projects" method="get">
        <input  v-model="Keywords" type="text" placeholder="Type Your Keyword" name="s" value="">
        <button v-on:click="getSearch"  class="top-quearys-style" type="submit">
          <i class="fa fa-long-arrow-right"></i>
        </button>
      </form>
      <div class="em-header-quearys-close text-center mrt10">
        <div class="em-quearys-menu">
          <i class="fa fa-close t-close em-s-hidden"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>